import React from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

const RunHistory = ({ projectId }) => {
  const navigate = useNavigate();

  const runs = [
    {
      name: "Docking+ADMET 筛选", id: "#20260707-001", status: "completed",
      duration: "12m 35s", start: "2026-07-07 14:30",
      nodes: [
        { label: "📥", status: "done" },
        { label: "🔌", status: "done" },
        { label: "💊", status: "done" },
        { label: "📤", status: "done" },
      ],
    },
    {
      name: "MD 精细筛选流程", id: "#20260707-002", status: "running",
      duration: "45m 12s", start: "2026-07-07 15:00",
      nodes: [
        { label: "📥", status: "done" },
        { label: "⚡", status: "done" },
        { label: "🎯", status: "running" },
        { label: "📤", status: "pending" },
      ],
    },
    {
      name: "FEP 计算", id: "#20260706-003", status: "failed",
      duration: "2h 10m", start: "2026-07-06 10:00", error: "Docking 节点超时",
      nodes: [
        { label: "📥", status: "done" },
        { label: "🔌", status: "done" },
        { label: "⚖️", status: "failed" },
      ],
    },
  ];

  const statusLabels = {
    completed: { label: "Completed", class: "completed" },
    running: { label: "Running", class: "running" },
    failed: { label: "Failed", class: "failed" },
    cancelled: { label: "Cancelled", class: "cancelled" },
  };

  return (
    <div className="fadein animation-duration-500" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <div className="screening-header">
        <span className="screening-header-icon">▶️</span>
        <span className="screening-header-title">Run History</span>
      </div>

      <div className="screening-body">
        {/* Filters */}
        <div className="screening-results-filters">
          <Dropdown value={null} options={[{ label: "All Workflows", value: null }]} placeholder="All Workflows"
            style={{ width: 160 }} />
          <Dropdown value={null} options={[{ label: "All Status", value: null }]} placeholder="All Status"
            style={{ width: 140 }} />
          <Dropdown value={null} options={[{ label: "This Week", value: null }]} placeholder="This Week"
            style={{ width: 120 }} />
          <span className="p-input-icon-left" style={{ flex: 1, maxWidth: 280 }}>
            <i className="pi pi-search" />
            <InputText placeholder="Search..." style={{ width: "100%", paddingLeft: 32 }} />
          </span>
        </div>

        {runs.length === 0 ? (
          <div className="screening-empty">
            <div className="screening-empty-icon">▶️</div>
            <div className="screening-empty-text">No run history yet</div>
            <div className="screening-empty-sub">Run a workflow to see execution history here</div>
          </div>
        ) : (
          runs.map((run, i) => {
            const st = statusLabels[run.status] || statusLabels.completed;
            return (
              <div key={i} className="screening-run-item"
                onClick={() => navigate(`editor/${i}?readonly=true`)}>
                <div className="screening-run-header">
                  <div>
                    <span className="screening-run-name">▶️ {run.name}</span>
                    <span className="screening-run-id" style={{ marginLeft: 8 }}>{run.id}</span>
                  </div>
                  <span className={`screening-run-status ${st.class}`}>{st.label}</span>
                </div>
                <div className="screening-run-details">
                  <span>⏱ {run.duration}</span>
                  <span>📅 {run.start}</span>
                </div>
                <div className="screening-run-nodes">
                  {run.nodes.map((n, j) => (
                    <span key={j} className={`screening-run-node-dot ${n.status}`}>{n.label}</span>
                  ))}
                </div>
                {run.error && (
                  <div style={{ marginTop: 8, fontSize: "0.8rem", color: "#ef4444", display: "flex", gap: 8, alignItems: "center" }}>
                    <span>❌ Error: {run.error}</span>
                    <Button label="Retry" icon="pi pi-refresh" className="p-button-sm p-button-text"
                      style={{ color: "#ef4444", fontSize: "0.8rem" }} />
                    <Button label="Logs" icon="pi pi-file" className="p-button-sm p-button-text"
                      style={{ fontSize: "0.8rem" }} />
                  </div>
                )}
                {run.status === "running" && (
                  <div style={{ marginTop: 8 }}>
                    <Button label="Cancel" icon="pi pi-times" className="p-button-sm p-button-text"
                      style={{ color: "#64748b", fontSize: "0.8rem" }} />
                  </div>
                )}
                {run.status === "completed" && (
                  <div style={{ marginTop: 8 }}>
                    <Button label="View Results →" icon="pi pi-arrow-right" className="p-button-sm p-button-text"
                      iconPos="right" style={{ color: "#4f46e5", fontSize: "0.8rem" }}
                      onClick={(e) => { e.stopPropagation(); navigate("results"); }} />
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default observer(RunHistory);
